module.exports = __webpack_public_path__ + "img/pen.ca8e3323.png";